import axios from 'axios';
import API_BASE_URL from '../config.js';
import AuthServices from './AuthServices.js';

const RegisterServices = async (userData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}api/user-register/`, userData);


        // si la peticion es 200: ok redirigimos al login
        if (response.status === 201) {
            console.log(response.status === 201)
            const ciam_id = userData['ciam_id']

            // llamamos la peticion del login nuevamente
            await AuthServices(ciam_id)
        }
    } catch (error) {
        console.error(error)
    }
}

export default RegisterServices;